import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ContactsPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <h1 className="text-5xl lg:text-6xl font-bold text-black leading-tight mb-8">
            {t('contacts.title')}
          </h1>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-20">
          <div className="max-w-2xl">
            <h2 className="text-3xl font-bold text-black mb-8">{t('contacts.company')}</h2>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1E3A8A]/10 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-[#1E3A8A]"></i>
                </div>
                <div>
                  <div className="text-xs uppercase text-gray-500 mb-2 tracking-wider">{t('contacts.addressLabel')}</div>
                  <div className="text-gray-700 text-base leading-relaxed">
                    {t('contacts.address')}<br />
                    {t('contacts.street')}
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#1E3A8A]/10 rounded-lg flex-shrink-0">
                  <i className="ri-mail-line text-2xl text-[#1E3A8A]"></i>
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-1">{t('contacts.email')}</div>
                  <a href={`mailto:${t('contacts.emailValue')}`} className="text-lg text-[#1E3A8A] hover:underline cursor-pointer whitespace-nowrap">
                    {t('contacts.emailValue')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
